import { apiClient } from '_app'
import { CancelToken } from 'axios'
import { ApiResponse } from 'dtos'
import { DOTRejectionReasonTypeDto } from 'dtos/conformity'

export const getDOTRejectionReasonTypes = (cancelToken?: CancelToken) =>
  apiClient.get<ApiResponse<DOTRejectionReasonTypeDto[]>>('/api/dot-rejection-reason-types', { cancelToken }).then(res => res.data)

export {
  createFilesToSign,
  getConformityLists,
  getConformityZipPreview,
  getConformtyZip,
  getReadyToSend,
  getReadyToSign,
  getSentToDOT,
  getSummarySheet,
  saveReadyToSendVehicles
} from './ConformityController'
